import React from "react";

/**
 * Legend for any chart with two or more series. A single-series chart gets no
 * legend - its title already says what is plotted, and a one-swatch box just
 * restates it.
 *
 * @param {{name: string, color: string, value?: number}[]} items
 */
export default function ChartLegend({ items = [] }) {
  if (items.length < 2) return null;

  return (
    <div className="viz-legend">
      {items.map((item) => (
        <span className="viz-legend-item" key={item.name}>
          <span className="viz-legend-swatch" style={{ background: item.color }} />
          <span>
            {item.name}
            {item.value !== undefined ? ` (${item.value})` : ""}
          </span>
        </span>
      ))}
    </div>
  );
}
